import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const subTitleCss = "s5ohl28";
export const SubTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subTitleCss, props.className)} />;
});
const introTextIsPhoneCss = "i8x0f6m";
const introTextCss = "i1p8z7hz";
export const IntroText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(introTextCss, {
    [introTextIsPhoneCss]: isPhone
  }, props.className)} />;
});
const paragraphTextAlignCenterCss = "p1stx01m";
const paragraphTextAlignRightCss = "pgpfy63";
const paragraphTextAlignJustifyCss = "p1at48x2";
const paragraphCss = "p1d1hyl4";
export const Paragraph = forwardRef((props, ref) => {
  const {
    textAlign,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paragraphCss, {
    [paragraphTextAlignCenterCss]: textAlign?.toString() === 'center',
    [paragraphTextAlignRightCss]: textAlign?.toString() === 'right',
    [paragraphTextAlignJustifyCss]: textAlign?.toString() === 'justify'
  }, props.className)} />;
});
const emptyStateListBoxIsPhoneCss = "e1fgl7v5";
const emptyStateListBoxCss = "e1fllkya";
export const EmptyStateListBox = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(emptyStateListBoxCss, {
    [emptyStateListBoxIsPhoneCss]: isPhone
  }, props.className)} />;
});
const errorMessageCss = "e1eimodn";
export const ErrorMessage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-component="error-message" className={classNames(errorMessageCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");